/**
*
* SelectWrapper
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

/**
 * @todo: using @argument type as the first preference
 */
const _onChange = (evt, props) => {
  const { onChange, valueKey, isMultiSelect, type } = props;
  if (evt) {
    if (isMultiSelect) {
      onChange('no_where_to_be_used');
      // do something
    } else {
      onChange(evt[valueKey], evt, type);
    }
  }
};

function SelectWrapper(props) {
  const { options, className, placeholder, labelKey, valueKey, onChange, value, isMultiSelect, type } = props;
  return (
    <Select
      name="form-field-name"
      placeholder={placeholder}
      className={className}
      options={options}
      labelKey={labelKey}
      valueKey={valueKey}
      onChange={(e) => _onChange(e, { onChange, isMultiSelect, valueKey, type })}
      value={value}
      multi={isMultiSelect}
    />
  );
}

SelectWrapper.propTypes = {
  options: PropTypes.array,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  isMultiSelect: PropTypes.bool,
  type: PropTypes.string,
};

SelectWrapper.defaultProps = {
  options: [
    { value: 'one', label: 'One' },
    { value: 'two', label: 'Two' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
  ],
  className: 'select-drop',
  placeholder: 'Select..',
  labelKey: 'label',
  valueKey: 'value',
  value: null,
  onChange: () => '',
  isMultiSelect: false,
  type: 'SelectValue',
};

export default SelectWrapper;



// WEBPACK FOOTER //
// client/components/SelectWrapper/index.js